<template lang="jade">
  .form-group
    .form-control.sm-select(ref="selectbox")

      input.input-search.to-click(
        type="text",
        v-on:click.stop="showPopup",
        :placeholder="filterText",
        :disabled="disabled",
        v-model="inputSearch",
        v-click-outside="hidePopup",
        @focus="$event.target.select()",
        ref="searchInput")

      span.pull-right.caret-fixed.to-click(v-on:click.stop="showPopup")
        b.caret
      .sm-select-popup1.pop-up-size(v-if="popupVisible", v-bind:style="{width: popUpMinWidth}", v-when-scroll-ends="{callback: loadMore}")
        ul
          ItemSelector(v-for="(item, index) in itemsData", :useState="useState", :item="item", :field="field",
                       :parseField="parseField", v-bind:key="index", :onChange="onSelect", key="item.id")

</template>


<script>
import { removeDuplicatesArray } from '../../utils'
import ClickOutside from 'vue-click-outside'
import ItemSelector from './ItemSelector.vue'

export default {
  props: {
    filterText: {required: true, type: String},
    callback: {required: true, type: Function},
    useState: {required: true, type: String},
    onChange: {type: Function},
    field: {'default': 'name', type: String},
    parseField: {type: Function},
    disabled: {type: Boolean, 'default': false}
  },
  async created () {
    if (this.selected) {
      let initialItem = await this.callback({id: this.selected.id})
      if (initialItem.body.success) {
        this.$commitUseState(this.useState, {selected: initialItem.body.success[0]})
      }
    }
    this.loadItems(this.currentPage, '')
  },
  computed: {
    currentPage () {
      return this.$getterUseState(this.useState).currentPage !== undefined ? this.$getterUseState(this.useState).currentPage : 0
    },
    totalPages () { return this.$getterUseState(this.useState).totalPages },
    selected () {
      return this.$getterUseState(this.useState).selected
    },
    inputSearch: {
      get () {
        if (this.searching) { return this.$getterUseState(this.useState).search }
        if (this.parseField) {
          return this.parseField(this.selected ? this.selected[this.field] : '')
        } else {
          return this.selected ? this.selected[this.field] : ''
        }
      },
      set (search) {
        this.$commitUseState(this.useState, {search, loaded: []})
        this.loadItems(0, search)
      }
    },
    itemsData () {
      return this.$getterUseState(this.useState).loaded
    },
    popUpMinWidth () { return this.$refs.selectbox.clientWidth + 'px' },
    searching () {
      const search = this.$getterUseState(this.useState).search
      return search !== '' && search !== undefined && search !== null
    },
    search () { return this.$getterUseState(this.useState).search }
  },
  data () {
    return {
      popupVisible: false
    }
  },
  methods: {
    showPopup () { this.$set(this, 'popupVisible', true) },
    hidePopup () { this.$set(this, 'popupVisible', false) },
    async loadItems (currentPage, search) {
      const result = await this.callback({page: currentPage, search})

      if (!result.body) {
        // NO CONTENT
        this.$dispatchUseState(this.useState, {loading: false, loaded: []})
        return
      }
      let parsedState = { loading: false }

      if (currentPage !== undefined) {
        parsedState = {
          ...parsedState,
          loaded: removeDuplicatesArray([...this.itemsData, ...result.body.success], 'id'),
          currentPage: currentPage,
          totalPages: result.body.totalPages || 1
        }
      } else {
        parsedState = {
          ...parsedState,
          loaded: result.body.success
        }
      }
      this.$dispatchUseState(this.useState, parsedState)
    },
    loadMore () {
      if (!this.totalPages || this.currentPage + 1 < this.totalPages) {
        this.loadItems(this.currentPage + 1, this.search)
      }
    },
    onSelect (item) {
      if (this.disabled) { return }

      this.$refs.searchInput.value = item.name
      this.hidePopup()
      this.$commitUseState(this.useState, {selected: item, search: null})
      if (this.onChange) {
        this.onChange(item)
      }
    }
  },
  components: { ItemSelector },
  directives: {ClickOutside}
}
</script>

<style scoped>
.pop-up-size {
  position: absolute !important;
  max-height: 200px;
  overflow: scroll;
  margin-top: 30px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}
.input-search {
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  float: left;
}
.caret-fixed {
  position: absolute;
  right: 25px;
}
</style>



// WEBPACK FOOTER //
// UniqueSelect.vue?c2d83798